// Components
import { Flex } from 'yard-utilities/components'

// Styles
import styles from './IconBox.module.sass'

interface IconBoxProps {
  children: JSX.Element
  size?: 'xs' | 'sm' | 'md' | 'lg'
  className?: string
  onClick?: () => void
}

const IconBox = ({
  children,
  size = 'xs',
  className = '',
  onClick
}: IconBoxProps) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      className={`${styles.box} ${styles[`box--${size}`]} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : ''}
    >
      {children}
    </Flex>
  )
}

export default IconBox
